import { http } from '@providers'
import { globalReactService } from '@commons'
import { IGenericApiResponse } from '@src/models'

const baseURL = globalReactService.signatureUrl

type Ipagination = {
  page: number
  items: number
  terms: string
}

const handleError = (err: any) => {
  console.log(err)
  throw err
}

export const getSigners = (q: Ipagination) => {
  return http
    .get(`${baseURL}/signers`, {
      params: {
        ...q
      }
    })
    .then(({ data, headers }) => {
      return {
        data,
        meta: {
          totalItems: parseInt(headers['total-count']),
          totalPages: parseInt(headers['total-pages'])
        }
      }
    })
    .catch(handleError)
}

export const promoteSigners = (
  tokens: string[]
): Promise<IGenericApiResponse> => {
  return http
    .post(`${baseURL}/signers`, { tokens })
    .then(({ data }) => data)
    .catch(handleError)
}

export const demoteSigners = (
  tokens: string[]
): Promise<IGenericApiResponse> => {
  return http
    .delete(`${baseURL}/signers`, { data: { tokens } })
    .then(({ data }) => data)
    .catch(handleError)
}